function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var PokerState = /*#__PURE__*/function () {
  function PokerState() {
    _classCallCheck(this, PokerState);
  }
  return _createClass(PokerState, [{
    key: "returnPlayerCharacterPool",
    value: function returnPlayerCharacterPool() {
      return ['player1', 'player2', 'player3', 'player4', 'player5', 'player6'];
    }

    // Deterministic shuffle so every peer assigns the same portraits for a game.
  }, {
    key: "shufflePlayerCharacters",
    value: function shufflePlayerCharacters() {
      var _this$game;
      var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var pool = this.returnPlayerCharacterPool().slice();
      var h = 2166136261;
      var s = String(seed || ((_this$game = this.game) === null || _this$game === void 0 ? void 0 : _this$game.id) || 'poker');
      for (var i = 0; i < s.length; i++) {
        h ^= s.charCodeAt(i);
        h = Math.imul(h, 16777619);
      }
      for (var _i = pool.length - 1; _i > 0; _i--) {
        h ^= h << 13;
        h ^= h >>> 17;
        h ^= h << 5;
        h >>>= 0;
        var j = h % (_i + 1);
        var tmp = pool[_i];
        pool[_i] = pool[j];
        pool[j] = tmp;
      }
      return pool;
    }
  }, {
    key: "ensurePlayerCharacters",
    value: function ensurePlayerCharacters() {
      var _this$game2, _this$game$players;
      if (!((_this$game2 = this.game) !== null && _this$game2 !== void 0 && _this$game2.state)) {
        return;
      }
      var n = ((_this$game$players = this.game.players) === null || _this$game$players === void 0 ? void 0 : _this$game$players.length) || 0;
      if (!Array.isArray(this.game.state.player_characters)) {
        this.game.state.player_characters = [];
      }
      if (this.game.state.player_characters.length >= n && n > 0) {
        return;
      }
      var pool = this.shufflePlayerCharacters(this.game.id);
      var used = new Set(this.game.state.player_characters);
      while (this.game.state.player_characters.length < n) {
        var next = pool.find(function (id) {
          return !used.has(id);
        }) || pool[this.game.state.player_characters.length % pool.length];
        this.game.state.player_characters.push(next);
        used.add(next);
      }
    }
  }, {
    key: "returnState",
    value: function returnState(num_of_players) {
      var _this$game3;
      var state = {};
      state.round = 1;
      state.flipped = 0;
      state.player_cards = {};
      state.player_cards_reported = 0;
      state.player_cards_required = 0;
      state.plays_since_last_raise = 0;
      state.big_blind_player = 1;
      state.small_blind_player = 2;
      state.button_player = 3;
      if (num_of_players == 2) {
        state.button_player = 2;
        state.big_blind_player = 1;
        state.small_blind_player = 2;
      }
      state.player_names = [];
      state.player_characters = [];
      state.player_pot = [];
      state.player_credit = [];
      state.passed = [];
      state.debt = [];
      state.chip_exchange = [];
      state.winners = [];
      state.last_fold = null;
      var characters = this.shufflePlayerCharacters((_this$game3 = this.game) === null || _this$game3 === void 0 ? void 0 : _this$game3.id);

      //
      // initializeGameStake should flesh this out
      //
      for (var i = 0; i < num_of_players; i++) {
        state.passed[i] = 0;
        state.player_pot[i] = 0;
        state.player_credit[i] = 0;
        state.debt[i] = 0;
        state.player_names[i] = this.app.keychain.returnUsername(this.game.players[i]);
        state.player_characters[i] = characters[i % characters.length];
        state.chip_exchange[i] = new Array(num_of_players).fill(0);
      }
      state.big_blind = 2;
      state.small_blind = 1;
      state.last_raise = 2;
      state.required_pot = 2;
      state.all_in = false;
      return state;
    }
  }, {
    key: "returnStats",
    value: function returnStats() {
      var stats = {};
      for (var i = 0; i < this.game.players.length; i++) {
        stats[this.game.players[i]] = {};
        stats[this.game.players[i]].hands = 0;
        stats[this.game.players[i]].wins = 0;
        stats[this.game.players[i]].folds = 0;
        stats[this.game.players[i]].walks = 0;
        stats[this.game.players[i]].vpip = 0;
        stats[this.game.players[i]].showdowns = 0;
      }
      return stats;
    }
  }, {
    key: "removePlayerFromState",
    value: function removePlayerFromState(pkey) {
      var index = this.game.players.indexOf(pkey);
      if (index >= 0 && index < this.game.state.player_names.length) {
        this.game.stats[pkey].final_chips = this.game.state.player_credit[index];
        this.game.state.player_names.splice(index, 1);
        if (Array.isArray(this.game.state.player_characters)) {
          this.game.state.player_characters.splice(index, 1);
        }
        this.game.state.player_pot.splice(index, 1);
        this.game.state.player_credit.splice(index, 1);
        this.game.state.passed.splice(index, 1);
        this.game.state.debt.splice(index, 1);
        for (var i = 0; i < this.game.players.length; i++) {
          if (index !== i) {
            this.game.state.chip_exchange[i].splice(index, 1);
          }
        }
        this.game.state.chip_exchange.splice(index, 1);
        return "".concat(this.game.stats[pkey].final_chips, " CHIPS");
      } else {
        console.warn('Invalid index removePlayerFromState');
      }
    }
  }, {
    key: "addPlayerToState",
    value: function addPlayerToState(pkey) {
      var index = this.game.players.indexOf(pkey);
      console.log(pkey, index, this.game.players);
      this.game.state.player_names.push(this.app.keychain.returnUsername(this.game.players[index]));
      if (!Array.isArray(this.game.state.player_characters)) {
        this.game.state.player_characters = [];
      }
      var pool = this.returnPlayerCharacterPool();
      var used = new Set(this.game.state.player_characters);
      var next = pool.find(function (id) {
        return !used.has(id);
      }) || pool[index % pool.length];
      this.game.state.player_characters.push(next);
      this.game.state.player_pot.push(0);
      this.game.state.player_credit.push(this.game.chips);
      this.game.state.passed.push(0);
      this.game.state.debt.push(0);
      for (var i = 0; i < this.game.players.length; i++) {
        if (index !== i) {
          this.game.state.chip_exchange[i].splice(index, 0, 0);
        } else {
          this.game.state.chip_exchange.splice(index, 0, new Array(this.game.players.length).fill(0));
        }
      }

      // And for stats...

      this.game.stats[pkey] = {};
      this.game.stats[pkey].hands = 0;
      this.game.stats[pkey].wins = 0;
      this.game.stats[pkey].folds = 0;
      this.game.stats[pkey].walks = 0;
      this.game.stats[pkey].vpip = 0;
      this.game.stats[pkey].showdowns = 0;
    }
  }]);
}();
module.exports = PokerState;